/* ==========================================================================
   Kenza Pro — Category Carousel
   Two-tracks architecture with mode switcher, dual-word headline morph,
   smart liquid glass arrows, URL deep linking, full a11y.
   ========================================================================== */
(function () {
  'use strict';

  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, root)  { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ============================================================
     A SINGLE TRACK (one mode worth of cards)
     One TrackController per mode-wrap. The Carousel orchestrates them.
     ============================================================ */
  function TrackController(wrap, carousel) {
    this.wrap     = wrap;
    this.mode     = wrap.dataset.mode;
    this.carousel = carousel;
    this.viewport = $('.kp-cat-carousel__viewport', wrap);
    this.track    = $('.kp-cat-carousel__track', wrap);
    this.cards    = $$('.kp-cat-card', wrap);
    this.dots     = $$('.kp-cat-dot', wrap);
    this.prevBtn  = $('.kp-cat-arrow--prev', wrap);
    this.nextBtn  = $('.kp-cat-arrow--next', wrap);

    this.activeIndex = 0;
    this.isDragging  = false;

    this._bind();
    this._updateActive(0, true);
    this._updateArrows();
  }

  TrackController.prototype._bind = function () {
    var self = this;

    /* dots */
    this.dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        self.goTo(i);
        self.carousel.restartAutoplay(true);
      });
    });

    /* arrows */
    if (this.prevBtn) this.prevBtn.addEventListener('click', function () {
      self.goTo(self.prevIndex());
      self.carousel.restartAutoplay(true);
    });
    if (this.nextBtn) this.nextBtn.addEventListener('click', function () {
      self.goTo(self.nextIndex());
      self.carousel.restartAutoplay(true);
    });

    /* scroll → update active card + arrows */
    var rafId = null;
    this.track.addEventListener('scroll', function () {
      if (rafId) window.cancelAnimationFrame(rafId);
      rafId = window.requestAnimationFrame(function () {
        self._onScroll();
        self._updateArrows();
      });
    }, { passive: true });

    /* desktop drag */
    var isDown = false, startX = 0, startScroll = 0;
    this.track.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      isDown = true;
      self.isDragging = false;
      startX = e.pageX;
      startScroll = self.track.scrollLeft;
    });
    this.track.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      var dx = e.pageX - startX;
      if (Math.abs(dx) > 5 && !self.isDragging) {
        self.isDragging = true;
        self.track.classList.add('is-dragging');
        self.carousel.pauseAutoplay();
      }
      if (self.isDragging) self.track.scrollLeft = startScroll - dx;
    });
    var endDrag = function () {
      if (!isDown) return;
      isDown = false;
      if (self.isDragging) {
        self.isDragging = false;
        self.track.classList.remove('is-dragging');
        self.snapToNearest();
        self.carousel.scheduleResumeAutoplay();
      }
    };
    this.track.addEventListener('mouseup', endDrag);
    this.track.addEventListener('mouseleave', endDrag);

    /* touch */
    this.track.addEventListener('touchstart', function () {
      self.carousel.userTouching = true;
      self.carousel.pauseAutoplay();
    }, { passive: true });
    this.track.addEventListener('touchend', function () {
      self.carousel.userTouching = false;
      self.carousel.scheduleResumeAutoplay();
    });

    /* keyboard */
    this.track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); self.goTo(self.prevIndex()); self.carousel.restartAutoplay(true); }
      if (e.key === 'ArrowRight') { e.preventDefault(); self.goTo(self.nextIndex()); self.carousel.restartAutoplay(true); }
      if (e.key === 'Home')       { e.preventDefault(); self.goTo(0); }
      if (e.key === 'End')        { e.preventDefault(); self.goTo(self.cards.length - 1); }
    });

    /* tilt (desktop, opt-in) */
    if (this.carousel.tiltEnabled && !prefersReducedMotion && window.matchMedia('(hover: hover)').matches) {
      this.cards.forEach(function (card) {
        var media = $('.kp-cat-card__media', card);
        if (!media) return;
        var raf = null;
        card.addEventListener('mousemove', function (e) {
          if (raf) return;
          raf = window.requestAnimationFrame(function () {
            var rect = card.getBoundingClientRect();
            var cx = (e.clientX - rect.left) / rect.width;
            var cy = (e.clientY - rect.top)  / rect.height;
            media.style.setProperty('--kp-tilt-x', ((cy - 0.5) * -4) + 'deg');
            media.style.setProperty('--kp-tilt-y', ((cx - 0.5) *  4) + 'deg');
            raf = null;
          });
        });
        card.addEventListener('mouseleave', function () {
          media.style.setProperty('--kp-tilt-x', '0deg');
          media.style.setProperty('--kp-tilt-y', '0deg');
        });
      });
    }
  };

  TrackController.prototype._onScroll = function () {
    if (!this.cards.length) return;
    var rect = this.track.getBoundingClientRect();
    var center = rect.left + rect.width / 2;
    var closest = 0, closestDist = Infinity;
    for (var i = 0; i < this.cards.length; i++) {
      var r = this.cards[i].getBoundingClientRect();
      var d = Math.abs(r.left + r.width / 2 - center);
      if (d < closestDist) { closestDist = d; closest = i; }
    }
    if (closest !== this.activeIndex) this._updateActive(closest, false);
  };

  TrackController.prototype._updateActive = function (idx, silent) {
    this.activeIndex = idx;
    this.cards.forEach(function (c, i) { c.classList.toggle('is-active', i === idx); });
    this.dots.forEach(function (d, i) {
      d.classList.toggle('is-active', i === idx);
      if (i === idx) d.setAttribute('aria-current', 'true');
      else d.removeAttribute('aria-current');
    });
    if (!silent && this.carousel.live) {
      var card = this.cards[idx];
      var title = card ? (card.dataset.title || 'Slide ' + (idx + 1)) : '';
      this.carousel.live.textContent = title + ' — slide ' + (idx + 1) + ' van ' + this.cards.length;
    }
  };

  /* Smart liquid-glass arrow visibility:
     prev hidden when at start (scrollLeft ≤ 4)
     next hidden when at end   (scrollLeft + clientWidth ≥ scrollWidth - 4) */
  TrackController.prototype._updateArrows = function () {
    if (!this.prevBtn || !this.nextBtn) return;
    var sl = this.track.scrollLeft;
    var sw = this.track.scrollWidth;
    var cw = this.track.clientWidth;
    var atStart = sl <= 4;
    var atEnd   = sl + cw >= sw - 4;
    this.prevBtn.hidden = atStart;
    this.nextBtn.hidden = atEnd;
  };

  TrackController.prototype.nextIndex = function () { return (this.activeIndex + 1) % this.cards.length; };
  TrackController.prototype.prevIndex = function () { return (this.activeIndex - 1 + this.cards.length) % this.cards.length; };

  TrackController.prototype.goTo = function (idx) {
    if (idx < 0 || idx >= this.cards.length) return;
    var card = this.cards[idx];
    var left = card.offsetLeft - this.track.offsetLeft;
    try {
      this.track.scrollTo({ left: left, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
    } catch (e) {
      this.track.scrollLeft = left;
    }
    this._updateActive(idx, false);
  };

  TrackController.prototype.snapToNearest = function () { this.goTo(this.activeIndex); };

  TrackController.prototype.reset = function () {
    this.activeIndex = 0;
    this.track.scrollLeft = 0;
    this._updateActive(0, true);
    this._updateArrows();
  };

  /* ============================================================
     CAROUSEL — orchestrates the track-wraps + mode switching + autoplay
     ============================================================ */
  function CategoryCarousel(root) {
    this.root      = root;
    this.live      = $('.kp-cat-carousel__live', root);
    this.switcher  = $('.kp-cat-switcher', root);
    this.switchBtns= $$('.kp-cat-switcher__btn', root);
    this.indicator = $('.kp-cat-switcher__indicator', root);
    this.morphSlot = $('.kp-cat-carousel__morph', root);
    this.morphWordA = $('.kp-cat-carousel__morph-word--a', root);
    this.morphWordB = $('.kp-cat-carousel__morph-word--b', root);

    this.autoplay     = root.dataset.autoplay === 'true';
    this.interval     = parseInt(root.dataset.interval, 10) || 5000;
    this.pauseOnHover = root.dataset.pauseOnHover !== 'false';
    this.tiltEnabled  = root.classList.contains('kp-cat-carousel--tilt');

    this.urlSyncEnabled = root.dataset.urlSyncEnabled === 'true';
    this.urlSyncParam   = root.dataset.urlSync || 'shop';

    this.modeWords = {
      category:  root.dataset.wordCategory  || 'Categorie',
      treatment: root.dataset.wordTreatment || 'Behandeling'
    };

    this.activeMode = root.dataset.defaultMode || 'category';

    /* read URL on first load */
    if (this.urlSyncEnabled) {
      try {
        var params = new URLSearchParams(window.location.search);
        var um = params.get(this.urlSyncParam);
        if (um === 'behandeling' || um === 'treatment') this.activeMode = 'treatment';
        else if (um === 'categorie' || um === 'category') this.activeMode = 'category';
      } catch (e) {}
    }

    /* Build track controllers per wrap */
    this.trackWraps = $$('.kp-cat-carousel__track-wrap', root);
    this.tracks = {};
    var self = this;
    this.trackWraps.forEach(function (wrap) {
      self.tracks[wrap.dataset.mode] = new TrackController(wrap, self);
    });

    this.hasModes = this.trackWraps.length > 1 && this.switchBtns.length > 1;

    /* shared state */
    this.autoplayTimer = null;
    this.isHovering    = false;
    this.isFocusWithin = false;
    this.userTouching  = false;
    this.inViewport    = false;
    this.isModeSwitching = false;
    this.observer      = null;

    this._bindGlobal();
    this._applyInitialMode();
    this._reveal();
    this._observe();
  }

  CategoryCarousel.prototype._bindGlobal = function () {
    var self = this;

    /* switcher buttons */
    this.switchBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var mode = btn.dataset.mode;
        if (mode && mode !== self.activeMode) self._setMode(mode, true);
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
          e.preventDefault();
          var other = self.activeMode === 'category' ? 'treatment' : 'category';
          self._setMode(other, true);
          var target = self.switchBtns.filter(function (b) { return b.dataset.mode === other; })[0];
          if (target) target.focus();
        }
      });
    });

    /* popstate (URL back/forward) */
    if (this.urlSyncEnabled && this.hasModes) {
      window.addEventListener('popstate', function () {
        try {
          var params = new URLSearchParams(window.location.search);
          var um = params.get(self.urlSyncParam);
          var newMode = 'category';
          if (um === 'behandeling' || um === 'treatment') newMode = 'treatment';
          if (newMode !== self.activeMode) self._setMode(newMode, false);
        } catch (e) {}
      });
    }

    /* hover/focus pause */
    if (this.pauseOnHover) {
      this.root.addEventListener('mouseenter', function () { self.isHovering = true; self.pauseAutoplay(); });
      this.root.addEventListener('mouseleave', function () { self.isHovering = false; self.scheduleResumeAutoplay(); });
    }
    this.root.addEventListener('focusin',  function () { self.isFocusWithin = true;  self.pauseAutoplay(); });
    this.root.addEventListener('focusout', function () { self.isFocusWithin = false; self.scheduleResumeAutoplay(); });

    /* visibility */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) self.pauseAutoplay();
      else if (self.autoplay) self.scheduleResumeAutoplay();
    });
  };

  CategoryCarousel.prototype._applyInitialMode = function () {
    if (!this.hasModes) {
      if (this.autoplay && !prefersReducedMotion) this._startAutoplay();
      return;
    }

    /* set initial button state */
    var self = this;
    this.switchBtns.forEach(function (btn) {
      var active = btn.dataset.mode === self.activeMode;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    /* show only the active wrap */
    this.trackWraps.forEach(function (w) {
      var active = w.dataset.mode === self.activeMode;
      w.hidden = !active;
      w.classList.toggle('is-active', active);
    });

    /* set initial headline word (no animation) */
    if (this.morphWordA) {
      this.morphWordA.textContent = this.modeWords[this.activeMode] || this.morphWordA.textContent;
      this.morphWordA.classList.add('is-current');
    }
    if (this.morphWordB) {
      this.morphWordB.textContent = '';
      this.morphWordB.classList.remove('is-current');
    }

    /* position indicator without transition */
    if (this.indicator) {
      this.indicator.style.transition = 'none';
      this._positionIndicator();
      // eslint-disable-next-line
      this.indicator.offsetHeight;
      this.indicator.style.transition = '';
    }

    if (this.autoplay && !prefersReducedMotion) this._startAutoplay();
  };

  CategoryCarousel.prototype._positionIndicator = function () {
    if (!this.indicator || !this.switcher) return;
    var activeBtn = this.switchBtns.filter(function (b) { return b.classList.contains('is-active'); })[0];
    if (!activeBtn) return;
    var swRect = this.switcher.getBoundingClientRect();
    var btRect = activeBtn.getBoundingClientRect();
    var offset = btRect.left - swRect.left - 4;     /* 4px = switcher padding */
    this.indicator.style.width = btRect.width + 'px';
    this.indicator.style.transform = 'translateX(' + offset + 'px)';
  };

  /* ============================================================
     MODE SWITCH — the orchestrated transition
     ============================================================ */
  CategoryCarousel.prototype._setMode = function (mode, updateUrl) {
    if (mode === this.activeMode || this.isModeSwitching) return;
    if (!this.tracks[mode]) return;
    this.isModeSwitching = true;
    var self = this;

    var newWord = this.modeWords[mode];

    /* 1. pause autoplay */
    this.pauseAutoplay();

    /* 2. mark switching state — current wrap fades */
    this.root.classList.add('is-mode-switching');

    /* 3. switcher button + indicator */
    this.switchBtns.forEach(function (btn) {
      var active = btn.dataset.mode === mode;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    this._positionIndicator();

    /* 4. dual-word headline morph */
    this._morphTo(newWord);

    /* 5. swap wraps after the fade is mid-way through (~220ms) */
    var swapDelay = prefersReducedMotion ? 0 : 220;
    window.setTimeout(function () {
      var oldMode = self.activeMode;
      self.activeMode = mode;

      self.trackWraps.forEach(function (w) {
        var active = w.dataset.mode === mode;
        if (active) {
          w.hidden = false;
          w.classList.add('is-active');
          /* reset the new track to slide 0 */
          if (self.tracks[mode]) self.tracks[mode].reset();
        } else {
          w.hidden = true;
          w.classList.remove('is-active');
        }
      });

      if (self.live) {
        self.live.textContent = 'Modus gewijzigd naar ' + (newWord || mode) + ', ' +
          (self.tracks[mode] ? self.tracks[mode].cards.length : 0) + ' opties beschikbaar';
      }

      /* 6. remove switching state so new wrap fades in */
      self.root.classList.remove('is-mode-switching');
    }, swapDelay);

    /* 7. clear switching flag after all animations done */
    var totalDuration = prefersReducedMotion ? 50 : 700;
    window.setTimeout(function () {
      self.isModeSwitching = false;
      self.scheduleResumeAutoplay();
    }, totalDuration);

    /* 8. update URL */
    if (updateUrl && this.urlSyncEnabled && window.history && window.history.replaceState) {
      try {
        var url = new URL(window.location.href);
        var val = mode === 'treatment' ? 'behandeling' : 'categorie';
        url.searchParams.set(this.urlSyncParam, val);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }
  };

  /* Dual-word crossfade: NO layout shift.
     The .is-current word stays in flow at all times.
     The other word, hidden by default, gets new text + .is-entering — overlays current.
     After animation completes, role swap: entering becomes current, leaving becomes hidden. */
  CategoryCarousel.prototype._morphTo = function (newWord) {
    if (!this.morphWordA || !this.morphWordB || !newWord) return;
    if (prefersReducedMotion) {
      var cur = this.morphWordA.classList.contains('is-current') ? this.morphWordA : this.morphWordB;
      cur.textContent = newWord;
      return;
    }
    var leaving  = this.morphWordA.classList.contains('is-current') ? this.morphWordA : this.morphWordB;
    var entering = leaving === this.morphWordA ? this.morphWordB : this.morphWordA;

    /* prep entering word with new text */
    entering.textContent = newWord;
    entering.removeAttribute('aria-hidden');

    /* trigger animation: leaving fades out, entering fades in (overlapping) */
    leaving.classList.add('is-leaving');
    entering.classList.add('is-entering');

    /* cleanup after animation completes — role swap */
    var totalMs = 600;
    window.setTimeout(function () {
      leaving.classList.remove('is-leaving', 'is-current');
      leaving.setAttribute('aria-hidden', 'true');
      entering.classList.remove('is-entering');
      entering.classList.add('is-current');
    }, totalMs);
  };

  /* ============================================================
     AUTOPLAY (shared across modes)
     ============================================================ */
  CategoryCarousel.prototype._startAutoplay = function () {
    if (!this.autoplay || prefersReducedMotion) return;
    if (this.isHovering || this.isFocusWithin || this.userTouching) return;
    if (!this.inViewport || this.isModeSwitching) return;
    var self = this;
    this.pauseAutoplay();
    this.autoplayTimer = window.setTimeout(function () {
      var t = self.tracks[self.activeMode];
      if (t) t.goTo(t.nextIndex());
      self._startAutoplay();
    }, this.interval);
  };

  CategoryCarousel.prototype.pauseAutoplay = function () {
    if (this.autoplayTimer) {
      window.clearTimeout(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  };

  CategoryCarousel.prototype.scheduleResumeAutoplay = function () {
    if (!this.autoplay || prefersReducedMotion) return;
    var self = this;
    window.setTimeout(function () {
      if (!self.isHovering && !self.isFocusWithin && !self.userTouching &&
          self.inViewport && !self.isModeSwitching) {
        self._startAutoplay();
      }
    }, 2000);
  };

  CategoryCarousel.prototype.restartAutoplay = function (afterUserAction) {
    this.pauseAutoplay();
    if (!this.autoplay || prefersReducedMotion) return;
    var self = this;
    var delay = afterUserAction ? 4000 : this.interval;
    window.setTimeout(function () {
      if (!self.isHovering && !self.isFocusWithin && !self.userTouching &&
          self.inViewport && !self.isModeSwitching) {
        self._startAutoplay();
      }
    }, delay);
  };

  /* ============================================================
     OBSERVERS — pause when out of view + entrance reveal
     ============================================================ */
  CategoryCarousel.prototype._observe = function () {
    if (typeof IntersectionObserver === 'undefined') {
      this.inViewport = true;
      return;
    }
    var self = this;
    this.observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        self.inViewport = e.isIntersecting;
        if (e.isIntersecting && self.autoplay) self.scheduleResumeAutoplay();
        else self.pauseAutoplay();
      });
    }, { threshold: 0.2 });
    this.observer.observe(this.root);
  };

  CategoryCarousel.prototype._reveal = function () {
    if (typeof IntersectionObserver === 'undefined' || prefersReducedMotion) {
      this.root.classList.add('is-revealed');
      return;
    }
    var self = this;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          self.root.classList.add('is-revealed');
          obs.disconnect();
        }
      });
    }, { threshold: 0.15 });
    obs.observe(this.root);
  };

  CategoryCarousel.prototype.destroy = function () {
    this.pauseAutoplay();
    if (this.observer) this.observer.disconnect();
  };

  /* ============================================================
     INIT + Shopify theme editor lifecycle
     ============================================================ */
  var instances = new WeakMap();

  function initAll(scope) {
    $$('.kp-cat-carousel', scope || document).forEach(function (el) {
      if (!instances.has(el)) instances.set(el, new CategoryCarousel(el));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    $$('.kp-cat-carousel', e.target).forEach(function (el) {
      var inst = instances.get(el);
      if (inst) {
        inst.destroy();
        instances.delete(el);
      }
    });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var carousel = e.target.closest('.kp-cat-carousel');
    if (!carousel) return;
    var inst = instances.get(carousel);
    if (!inst) return;
    var card = e.target.closest('.kp-cat-card');
    if (!card) return;
    var wrap = card.closest('.kp-cat-carousel__track-wrap');
    if (!wrap) return;
    var mode = wrap.dataset.mode;
    var track = inst.tracks[mode];
    if (!track) return;
    if (mode !== inst.activeMode) inst._setMode(mode, false);
    var idx = track.cards.indexOf(card);
    if (idx >= 0) {
      window.setTimeout(function () { track.goTo(idx); }, 250);
    }
  });

  /* re-position switcher indicator on resize */
  var resizeRAF = null;
  window.addEventListener('resize', function () {
    if (resizeRAF) window.cancelAnimationFrame(resizeRAF);
    resizeRAF = window.requestAnimationFrame(function () {
      $$('.kp-cat-carousel').forEach(function (el) {
        var inst = instances.get(el);
        if (!inst) return;
        if (inst.indicator) {
          inst.indicator.style.transition = 'none';
          inst._positionIndicator();
          // eslint-disable-next-line
          inst.indicator.offsetHeight;
          inst.indicator.style.transition = '';
        }
        /* recompute arrow visibility for the active track */
        var t = inst.tracks[inst.activeMode];
        if (t) t._updateArrows();
      });
    });
  });
})();